import axios from 'axios';

import { REACT_APP_API_URL } from 'src/constants';

const client = axios.create({
  baseURL: REACT_APP_API_URL,
  withCredentials: true,
});

client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  async (error) => {
    return await Promise.reject(error);
  },
);

client.defaults.headers.common = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

const get = async (URL, params) => {
  return await client.get(`${URL}`, { params }).then((response) => response?.data);
};

const post = async (URL, payload) => {
  return await client.post(`${URL}`, payload).then((response) => response?.data);
};

function appendFormData(formData, data, parentKey) {
  if (
    data &&
    typeof data === 'object' &&
    !(data instanceof FormData) &&
    !(data instanceof File) &&
    !(data instanceof Blob)
  ) {
    Object.keys(data).forEach((key) => {
      const newKey = parentKey ? `${parentKey}[${key}]` : key;
      appendFormData(formData, data[key], newKey);
    });
  } else {
    formData.append(parentKey, data ?? '');
  }
}

const post_form = async (URL, data) => {
  let formData;

  if (data instanceof FormData) {
    formData = data;
  } else {
    formData = new FormData();
    appendFormData(formData, data);
  }

  return client
    .post(URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => response?.data);
};

const patch = async (URL, payload) => {
  return await client.patch(`${URL}`, payload).then((response) => response?.data);
};

const delete_req = async (URL) => {
  return await client.delete(`${URL}`).then((response) => response?.data);
};

const apiClient = {
  post,
  post_form,
  get,
  patch,
  delete_req,
};

export { apiClient };
